<div class="row" style="margin-right:0px;margin-left:0px;">
  <div class="offset-md-2 col-md-8 p-5 bg-apportis-secondary" style="margin-top: 5%">
    <div style="padding-bottom: 20px;">
      <nav class="navbar navbar-expand fixed-top px-3" style="padding:5px; box-shadow: 0 1px 1px 0px #ddd;">
        <a class="navbar-brand mr-auto" style="padding-top: 0.2rem; padding-bottom: .2rem;max-width:180px;height:54px;">
          <img src="./assets/apportis-new-logo.png" alt="logo-dark" style="max-width: 100%;max-height: 100%;">

        </a>

      </nav>
    </div>

    <div class="center text-center">
      <h1 class="display-4">Look's like you shouldn't be here..!</h1>
      <h2 class="mb-5">401 Unauthorized</h2>
      <h4>You are not authorized to view the resource you are trying. If you feel this isn't right, please contact
        administrator</h4>
    </div>

  </div>
</div>